// Fila «Vincular dispositivo» del menú de cuenta (CC-CONSOLE#1523). La ve quien
// administra la compañía o la plataforma, con sesión: vincular un equipo escribe
// en su compañía real.

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useInRouterContext } from "react-router-dom";

import { LINK_DEVICE_PATH } from "../../pages/devices/link/linkDevice";
import { useSandboxStore } from "../sandbox/sandboxStore";

const ROW_CLASS =
  "flex min-h-[44px] items-center gap-3 px-4 text-left text-sm text-content-secondary transition-colors hover:bg-subtle hover:text-content";

export function LinkDeviceMenuRow({ onNavigate }: { onNavigate?: () => void }) {
  const { t } = useTranslation("common");
  const canLink = useSandboxStore((s) => s.canLink);
  const load = useSandboxStore((s) => s.load);
  // El menú puede pintarse fuera del router (pruebas, vistas sueltas): ahí es un enlace plano.
  const inRouter = useInRouterContext();
  useEffect(() => {
    void load();
  }, [load]);
  if (!canLink) return null;

  const content = (
    <>
      <i className="ri-link text-[15px] text-content-muted" aria-hidden="true" />
      {t("sandbox.linkDevice", "Vincular dispositivo")}
    </>
  );
  return inRouter ? (
    <Link to={LINK_DEVICE_PATH} onClick={onNavigate} className={ROW_CLASS} data-testid="menu-link-device">
      {content}
    </Link>
  ) : (
    <a href={LINK_DEVICE_PATH} onClick={onNavigate} className={ROW_CLASS} data-testid="menu-link-device">
      {content}
    </a>
  );
}
